import { Show, SimpleShowLayout, TextField } from "react-admin";

const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="pseudo" label="Pseudo" />
      <TextField source="full_name" label="Full name" />
      <TextField source="email" label="Email" />
    </SimpleShowLayout>
  </Show>
);

export default UserShow;
